import i18next from "../../config/i18next";
import i18nExample from "./i18n/fr.json";
import ListInvoicesPage from "./pages/list-invoices-page/list-invoices-page";

i18next.addResourceBundle("fr", "invoices", i18nExample);

const Invoices = { ListInvoicesPage };

export default Invoices;
